/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vehicle } from '../../models/vehicle';
import { VehicleUpdateRequest } from '../../models/vehicle-update-request';

export interface UpdateVehicle$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: VehicleUpdateRequest
}

export function updateVehicle(http: HttpClient, rootUrl: string, params: UpdateVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
  const rb = new RequestBuilder(rootUrl, updateVehicle.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vehicle>;
    })
  );
}

updateVehicle.PATH = '/api/v1/vehicles/{id}';
